import classNames from 'classnames';
import { FC } from 'react';

interface Props {
  title: string;
  description: string;
  author: string;
  location: string;
  photo?: string;
  backup?: boolean;
}

export const QuoteCard: FC<Props> = ({ title, description, author, location, photo, backup }) => {
  return (
    <div className={classNames('get-started-quote-card', { backup })}>
      <div className="quote-card-texts">
        <span className="h4-text semi-bold">{title}</span>
        <span className="h4-text light-font">"{description}"</span>
      </div>
      <div className="quote-card-author">
        {photo && !backup && (
          <img
            className="quote-card-author-photo"
            src={photo}
            alt={author}
            width={90}
            height={90}
            loading="lazy"
          />
        )}
        <span className="body-text color-gray">
          {author}, {location}
        </span>
      </div>
    </div>
  );
};
